export default __webpack_public_path__ + "static/media/2.87f71a1c.webp";